import React, { useState } from "react";
import { Tooltip, IconButton } from "@mui/material";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * @param {{text: string}} props
 */

export function CopyIcon({ text }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Tooltip title={copied ? "Zkopírováno!" : "Kopírovat"} arrow>
      <IconButton
        onClick={handleCopy}
        size="small"
        aria-label="Kopírovat do schránky"
        sx={{ ml: 0.5 }}
      >
        <FontAwesomeIcon size="xs" icon={copied ? faCheck : faCopy} />
      </IconButton>
    </Tooltip>
  );
}
